module.exports = __webpack_public_path__ + "static/media/more.4b798f63.svg";